// 텍스트 뷰어 컨텐츠가 끝났는지를 리턴합니다.
// 현재 챕터가 총 챕터와 같을 경우 뷰어 엔드입니다. isDone이 항상 true 입니다.

import {MAX_PROGRESS_RATE} from '../constant/viewerConstant';

// 현재 챕터가 총 챕터 -1 일경우 마지막 챕터인 경우입니다. 마지막 챕터이고 rate가 10000일 때만 다 봤다고 처리합니다.
export function checkTextViewerIsDone({
  rate,
  currentChapterId,
  chapterCount,
}: {
  rate: number;
  currentChapterId: number;
  chapterCount: number;
}): boolean {
  return (
    currentChapterId === chapterCount ||
    (currentChapterId === chapterCount - 1 && rate === MAX_PROGRESS_RATE)
  );
}
